<template>
    <v-container ma-0 pa-0>
        <v-textarea
            contenteditable="true"
            @dragenter="dragEnterCommentTextarea()"
            @dragleave="dragLeaveCommentTextarea()"
            @drop.prevent="dropCountryCommentTextarea()"
            v-bind:class="{ active: isActive }"
            filled
            name="input-7-4"
            :label="label"
            v-model="comment"
            rows="3"
            prepend-icon="mdi-comment"
            append-outer-icon="mdi-water"
            :maxlength="maxlength"
        ></v-textarea>
    </v-container>
</template>

<script>
    // import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../main';


    export default {
        name : 'commenttextarea',

        /* >>> *************************************************************** / /* Props */
        props : {

            value       : [ String, null ],
            label       : String,
            maxlength   : String

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CommentTextarea.vue >>> created');
            eventBus.$on('dragendproceedingslist', this.onDragend_InSelectedProceedingsList);
            eventBus.$on('dragendhotelslist', this.onDragend_InSelectedHotelsList);
            eventBus.$on('dragendtrainingslist', this.onDragend_InSelectedTrainingsList);
            eventBus.$on('dragendmeetingslist', this.onDragend_InSelectedMeetingsList);
            eventBus.$on('dragendstandbylist', this.onDragend_InSelectedStandbyList);
            eventBus.$on('dragendsicknesslist', this.onDragend_InSelectedSicknessList);
            eventBus.$on('dragendunableflightlist', this.onDragend_InSelectedUnableFlightList);
            eventBus.$on('dragendofficelist', this.onDragend_InSelectedOfficeList);
            eventBus.$on('dragenddayofflist', this.onDragend_InSelectedDayoffList);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CommentTextarea.vue >>> mounted');
            this.setComment();

        }, // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note: No need to reset something here.
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CommentTextarea.vue >>> beforeDestroy');
            eventBus.$off('dragendproceedingslist', this.onDragend_InSelectedProceedingsList);
            eventBus.$off('dragendhotelslist', this.onDragend_InSelectedHotelsList);
            eventBus.$off('dragendtrainingslist', this.onDragend_InSelectedTrainingsList);
            eventBus.$off('dragendmeetingslist', this.onDragend_InSelectedMeetingsList);
            eventBus.$off('dragendstandbylist', this.onDragend_InSelectedStandbyList);
            eventBus.$off('dragendsicknesslist', this.onDragend_InSelectedSicknessList);
            eventBus.$off('dragendunableflightlist', this.onDragend_InSelectedUnableFlightList);
            eventBus.$off('dragendofficelist', this.onDragend_InSelectedOfficeList);
            eventBus.$off('dragenddayofflist', this.onDragend_InSelectedDayoffList);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                comment: null,
                // >>> --------------------------
                isActive: false, // DnD highlight
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch : {

            value() {

                this.setComment();

            }, // eo value()

            comment(value) {

                this.$emit('input', value);

            }, // eo comment()

        }, // eo watch{}
        /* <<< ****************************************************************/




        /* >>> *************************************************************** / /* Methods */
        methods : {

            /******************************************************************* 'Listeners - Eventbus'
            * Listeners:EventBus:
            *******************************************************************/
            /******************************************************************* 'Proceedings - Drop'
            * onDragend_InSelectedProceedingsList()
            *
            * Desc:
            * Note:
            *
            */
            onDragend_InSelectedProceedingsList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CommentTextarea.vue >>> onDragend_InSelectedProceedingsList');
                this.comment = params.proObject.info; // set dropped info/comment/notes

            }, // eo function onDragend_InSelectedProceedingsList()


            /******************************************************************* 'Hotels - Drop'
            * onDragend_InSelectedHotelsList()
            *
            * Desc:
            * Note:
            *
            */
            onDragend_InSelectedHotelsList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CommentTextarea.vue >>> onDragend_InSelectedHotelsList');
                this.comment = params.hotelObject.comment; // set dropped info/comment/notes

            }, // eo function onDragend_InSelectedHotelsList()


            /******************************************************************* 'Trainings - Drop'
            * onDragend_InSelectedTrainingsList()
            *
            * Desc:
            * Note:
            *
            */
            onDragend_InSelectedTrainingsList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CommentTextarea.vue >>> onDragend_InSelectedTrainingsList');
                this.comment = params.trainingObject.notes; // set dropped info/comment/notes

            }, // eo function onDragend_InSelectedTrainingsList()


            /******************************************************************* 'Meetings - Drop'
            * onDragend_InSelectedMeetingsList()
            *
            * Desc:
            * Note:
            *
            */
            onDragend_InSelectedMeetingsList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CommentTextarea.vue >>> onDragend_InSelectedMeetingsList');
                this.comment = params.dutyComment; // set dropped info/comment/notes

            }, // eo function onDragend_InSelectedMeetingsList()


            /******************************************************************* 'Standby - Drop'
            * onDragend_InSelectedStandbyList()
            *
            * Desc:
            * Note:
            *
            */
            onDragend_InSelectedStandbyList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CommentTextarea.vue >>> onDragend_InSelectedStandbyList');
                this.comment = params.dutyComment; // set dropped info/comment/notes

            }, // eo function onDragend_InSelectedStandbyList()


            /******************************************************************* 'Sickness - Drop'
            * onDragend_InSelectedSicknessList()
            *
            * Desc:
            * Note:
            *
            */
            onDragend_InSelectedSicknessList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CommentTextarea.vue >>> onDragend_InSelectedSicknessList');
                this.comment = params.dutyComment; // set dropped info/comment/notes

            }, // eo function onDragend_InSelectedSicknessList()


            /******************************************************************* 'UnableFlight - Drop'
            * onDragend_InSelectedUnableFlightList()
            *
            * Desc:
            * Note:
            *
            */
            onDragend_InSelectedUnableFlightList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CommentTextarea.vue >>> onDragend_InSelectedUnableFlightList');
                this.comment = params.dutyComment; // set dropped info/comment/notes

            }, // eo function onDragend_InSelectedUnableFlightList()


            /******************************************************************* 'Office - Drop'
            * onDragend_InSelectedOfficeList()
            *
            * Desc:
            * Note:
            *
            */
            onDragend_InSelectedOfficeList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CommentTextarea.vue >>> onDragend_InSelectedOfficeList');
                this.comment = params.dutyComment; // set dropped info/comment/notes

            }, // eo function onDragend_InSelectedOfficeList()


            /******************************************************************* 'Dayoff - Drop'
            * onDragend_InSelectedDayoffList()
            *
            * Desc:
            * Note:
            *
            */
            onDragend_InSelectedDayoffList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CommentTextarea.vue >>> onDragend_InSelectedDayoffList');
                this.comment = params.dutyComment; // set dropped info/comment/notes

            }, // eo function onDragend_InSelectedDayoffList()




            /*******************************************************************
            * Setters:
            *******************************************************************/
            /*******************************************************************
            * setComment()
            *
            * Desc:
            * Note:
            *
            */
            setComment: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CommentTextarea.vue >>> setComment');
                me.comment = this.value;

            }, // eo function setComment()



            /******************************************************************* 'Listeners - DnD'
            * Drag&Drop (DnD):
            *******************************************************************/
            /*******************************************************************
            * dragEnterCommentTextarea()
            *
            * Desc: Drop enters CommentTextarea.
            * Note:
            *
            */
            dragEnterCommentTextarea: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CommentTextarea.vue >>> dragEnterCommentTextarea');
                this.isActive = true;

            }, // eo function dragEnterCommentTextarea()


            /*******************************************************************
            * dragLeaveCommentTextarea()
            *
            * Desc: Drop leaves CountCommentTextareayCombo.
            * Note:
            *
            */
            dragLeaveCommentTextarea: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CommentTextarea.vue >>> dragLeaveCommentTextarea');
                this.isActive = false;

            }, // eo function dragLeaveCommentTextarea()


            /*******************************************************************
            * dropCountryCommentTextarea()
            *
            * Desc: Drop onto CommentTextarea.
            * Note:
            * TODO: Some var = true in Case of droped? Maybe Later.
            * TODO: Problem is: U have 2 Dropzones.
            *
            */
            dropCountryCommentTextarea: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/CommentTextarea.vue >>> dropCountryCommentTextarea');
                this.isActive = false;

            }, // eo function dropCountryCommentTextarea()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style>
    .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
        text-transform: none !important;
    }
</style>